enum DocumentOwnerTypeEnum {
  FIRM = 'firm',
  FIRM_ASSOCIATION = 'firmAssociation',
  FIRM_GROUP = 'firmGroup',
  RESELLER = 'reseller',
}

export default DocumentOwnerTypeEnum;
